import * as React from 'react';

import {EmailSequenceName} from '../email-sequence-name/email-sequence-name';

type Props = {
    sequenceName: string;
    messageCount: number;
};

export function EmailSequenceTemplateCell(props: Props) {
    return <EmailSequenceName {...props} />;
}
